module.exports = __webpack_public_path__ + "assets/descend.664a0837.svg";